const state = {
    locations: []
  }

  const mutations = {
    setLocations (state, locations) {
      state.locations = locations
    }
  }

  const getters = {
    getLocations (state) {
      return state.locations
    }
  }

  export default {
    namespaced: true,
    state,
    mutations,
    getters,
    // actions
  }
